export function normalizeNumber(val:any, prevVal:any) {
  if (val) {
    return (/^\d+$/.test(val)) ? val : prevVal
  }
  return val;
}